import { createSelector } from 'reselect';

import { relativeContextItemsByHitSetKey } from '@Containers/RelativeContext/RelativeContextSelectors';
import { activeBreadCrumbContext } from '@Containers/Breadcrumbs/BreadcrumbsSelectors';
import { stateParamsSelectorFactory } from '@Selectors/StateParamsSelectors';

import { dpitems, tgitems, reactions, citations, substances } from '@Constants';

export const availableRelativeContext = createSelector(
  [relativeContextItemsByHitSetKey, activeBreadCrumbContext],
  // eslint-disable-next-line no-shadow
  (relativeContextItemsByHitSetKey, activeBreadCrumbContext) => {
    if (!relativeContextItemsByHitSetKey || !activeBreadCrumbContext) {
      return null;
    }

    return relativeContextItemsByHitSetKey.filter((item) => {
      const context = item.get('context');
      return context !== dpitems && context !== activeBreadCrumbContext;
    });
  }
);

export const isHeatmapContextPresent = createSelector(
  [relativeContextItemsByHitSetKey],
  // eslint-disable-next-line no-shadow
  (relativeContextItemsByHitSetKey) => {
    return (
      relativeContextItemsByHitSetKey &&
      !!relativeContextItemsByHitSetKey.find((item) => item.get('context') === dpitems && item.get('resultSize') > 0)
    );
  }
);

export const baseParamsForSorting = stateParamsSelectorFactory([
  'context',
  'databaseId',
  'pageNumber',
  'resultName',
  'searchId',
  'hitSetKey',
]);

export function isTgitemsContext(state) {
  return activeBreadCrumbContext(state) === tgitems;
}

export function isReactionsContext(state) {
  return activeBreadCrumbContext(state) === reactions;
}

export function isCitationsContext(state) {
  return activeBreadCrumbContext(state) === citations;
}

export function isSubstancesContext(state) {
  return activeBreadCrumbContext(state) === substances;
}
